import { useRouter } from 'next/router';

/**
 *
 * @returns object with tag filters
 * filterTagFromUrl: get tag key from url
 * noFilterTagUrl: get url without selected tag key
 * createFilterUrl: create url with given tag key
 */
export const useRatingFilterTag = () => {
  const { query, pathname } = useRouter();
  const { ftag, ...queryWithoutFtag } = query;

  const noFilterTagUrl = {
    pathname,
    query: queryWithoutFtag,
  };

  const filterTagFromUrl =
    (ftag && (Array.isArray(ftag) ? ftag[0] : ftag).replace('f-', '')) || null;

  const createFilterUrl = (tag: string) => ({
    pathname: pathname.includes('/rating/') ? pathname : `${pathname}/rating/[[...ftag]]`,
    query: { ...query, ftag: `f-${tag}` },
  });

  return {
    filterTagFromUrl,
    noFilterTagUrl,
    createFilterUrl,
  };
};
